import { Directive, TemplateRef } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[sectionContainerBody]'
})
export class SectionContainerBodyDirective {
  constructor(public tpl: TemplateRef<any>) {}
}
